export default __webpack_public_path__ + "static/media/5.6e9e8d2e.png";